import React from "react";
import { Flex } from "@UI/Components/Flex/Flex";
import { Check } from "@UI/Components/Icons/Check";
import { Xmark } from "@UI/Components/Icons/Xmark";
import { Icon } from "@UI/Components/Icon/Icon";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { Text } from "@UI/Components/Text/Text";
import messages from "./messages";

interface IReachedStatus {
  reached: boolean;
}

export const ReachedStatus = ({ reached }: IReachedStatus) => {
  return (
    <Flex
      backgroundColor={reached ? "green.500" : "gray.500"}
      justifyContent="space-around"
      alignItems="center"
      px="8px"
      py="2px"
      borderRadius="100px"
      w="fit-content"
    >
      <Icon
        as={reached ? Check : Xmark}
        w={4}
        h={4}
        color="white"
        fontWeight={700}
      />
      <Text color="white" as="span" ml={1} fontWeight={700} fontSize={12}>
        {reached ? (
          <FormattedMessage {...messages.reached} />
        ) : (
          <FormattedMessage {...messages.notReached} />
        )}
      </Text>
    </Flex>
  );
};
